import React from 'react';
import { classNames } from '../../utils/style';
import { PictoName, pictosLibrary } from './pictosLibrary';
import { IllustrationName } from './illustrationLibrary';
import { Icon } from './Icon';
import { getColor } from './logic';

export interface SvgProps {
  className: string;
}

export interface PictoProps {
  className?: string;
  name: PictoName | IllustrationName;
  url?: string;
  variant?: 'light' | 'dark' | 'white';
  loading?: 'lazy' | 'eager';
  width?: number;
  height?: number;
  disablePadding?: boolean;
  size?: 'big' | 'small';
  classNameImg?: string;
  twTextColor?: string;
}

export const Picto = ({
  className,
  name: _name,
  variant,
  disablePadding,
  size,
  classNameImg,
  twTextColor,
  loading = 'lazy',
}: PictoProps) => {
  const name = _name.toLowerCase() as PictoName | IllustrationName;
  const isPicto = pictosLibrary.includes(name as PictoName);
  const color = getColor(variant);

  return (
    <div
      className={classNames(
        'Picto',
        className,
        'rounded-6',
        !disablePadding && isPicto && 'p-[10px]',
        !disablePadding && !isPicto && 'p-[5px]',
        size === 'big' && 'h-56 w-56',
        size === 'small' && 'h-40 w-40',
        variant === 'light' && 'bg-blue-21',
        isPicto && variant === 'dark' && 'bg-blue-301',
        !twTextColor ? color : twTextColor,
      )}
    >
      <Icon
        name={name}
        className={classNames(classNameImg, 'h-full w-full')}
        variant={variant}
        loading={loading}
      />
    </div>
  );
};
